<template>
  <div class="check-in">
    <section class="check-in__header">
      <div class="check-in__area">
        <ClockSvg class="checkin__icon" />
      </div>

      <h1 class="check-in__title">Inicie agora mesmo seu pré-atendimento.</h1>
    </section>
    <div class="check-in__content">
      <form class="check-in__form" @submit.prevent="handleForm">
        <VInput
          class="check-in__input"
          label="Insira o CPF da pessoa a ser atendida"
          v-model="cpf"
          v-mask="'###.###.###-##'"
          :errorMessage="errorMessageCPF"
          inputmode="numeric"
          maxlength="14"
          @keypress="inputAllowNumbersOnly"
          @focus="keyboardUpReposition"
        />
        <div class="check-in__btn">
          <VButton text="Começar pré-atendimento" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import checkinMixins from '@/utils/mixins/checkin.mixins';
import validateCpf from '@/utils/helpers/validation/validateCpf';

import {
  CPF_NOT_VALID,
  CPF_WRONG_SIZE,
  LOCAL_STORAGE_CPF,
} from '@/utils/constants/checkin.constants';

export default {
  name: 'CheckinMainFlow',
  mixins: [checkinMixins],
  data: () => ({
    cpf: '',
    errorMessageCPF: '',
  }),
  created() {
    this.inputCPFAutofiller();
  },
  watch: {
    cpf() {
      this.errorMessageCPF = '';
    },
  },
  methods: {
    /**
     * @method handleForm
     * @description Set CPF in localStorage and start check-in if the data is valid
     */
    handleForm() {
      const cpfIsValid = this.CPFValidation();
      if (!cpfIsValid) {
        return;
      }
      const userCpf = this.unmaskedCpf(this.cpf);
      sessionStorage.setItem(LOCAL_STORAGE_CPF, userCpf);
      if (cpfIsValid) {
        this.$emit('submit-form', userCpf);
      }
    },
    /**
     * @method CPFValidation
     * @description Checks if inputted value if an valid CPF and adds masker
     */
    CPFValidation() {
      const isCpfLengthValid = this.cpf.length === 14;

      const isCpfNumberValid = validateCpf(this.unmaskedCpf(this.cpf));
      if (!this.cpf || !isCpfLengthValid) {
        this.errorMessageCPF = CPF_WRONG_SIZE;
        return false;
      }

      if (isCpfLengthValid && !isCpfNumberValid) {
        this.errorMessageCPF = CPF_NOT_VALID;
        return false;
      }
      return true;
    },
    /**
     * @method keyboardUpReposition
     * @description Scrolls to button element when digital keyboard is displayed
     */
    keyboardUpReposition() {
      const buttonElement = this.$el.getElementsByClassName('check-in__btn')[0];
      const oldScreenHeight = window.innerHeight;
      let newScreenHeight;

      setTimeout(() => {
        newScreenHeight = window.innerHeight;
        if (oldScreenHeight > newScreenHeight && buttonElement) {
          buttonElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
.check-in {
  &__header {
    border: none;
    margin-top: 40px;
    height: 50vh;
    max-width: 320px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__item {
    & i {
      border: none;
      display: flex;
      width: 100%;
      height: 40px;
    }
  }

  &__area {
    width: 72px;
    height: 72px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: var(--color-slider-circle);

    & svg {
      max-width: 33px;
      max-height: 33px;

      * {
        fill: var(--color-slider);
      }
    }
  }

  &__title {
    display: flex;
    text-align: left;
    color: #161616;
    font-size: var(--font-size-4);
    line-height: 133%;
    font-weight: 600;

    @media (min-width: 321px) {
      font-size: var(--font-size-5);
    }
  }

  &__input {
    margin: 15% 0 5% 0;
  }

  &__content {
    &--combo {
      & > button {
        margin-top: 16px;
      }
    }
  }
}
</style>
